import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=1d85ac6f&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d85ac6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d85ac6f')) {
      api.createRecord('1d85ac6f', component.options)
    } else {
      api.reload('1d85ac6f', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=1d85ac6f&scoped=true&", function () {
      api.rerender('1d85ac6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DJzdC5HEaPRb/JS/comp/SearchFilterTokens.vue"
export default component.exports